import { reactive, set } from 'vue-demi';
const { useCommonApi, useUser } = require('@fegobull/webapi').use;
const request = useCommonApi('self-selected-stocks');
const selfSelectedButtonRequest = useCommonApi('self-selected-button');
const { isLogin } = useUser();

export default (props, stockList, wchNumMap) => {
    const selfSelectedMap = reactive({});

    /* 股票图表数据 */
    const getSelectStatus = async (stock) => {
        if (!isLogin) {
            return;
        }
        const { stockId } = stock;
        let res = false;
        const rsp = await request.get('status', { stockId });
        if (rsp.code === 10002) {
            res = false;
        }
        res = rsp?.data?.result ?? false;
        set(selfSelectedMap, stock.stockId, res);
    };

    const setSelectStatus = async (stock, selected) => {
        const { stockId } = stock;
        await request.post(selected ? 'cancelSubscribeStock' : 'subscribeStock', { stockId });
        set(selfSelectedMap, stock.stockId, !selected);
        // 改变添加自选股数量，只有在自选股列表中才会显示
        if (props.showAddWchCount) {
            if (selected) {
                // 取消添加，数量减一，最小为0
                const result = (wchNumMap[stock.stockId] || 0) - 1;
                set(wchNumMap, stock.stockId, result < 0 ? 0 : result);
            } else {
                set(wchNumMap, stock.stockId, (wchNumMap[stock.stockId] || 0) + 1);
            }
        }
    };

    // 产品需求，一直展示为添加全部
    const addAll = async () => {
        if (!stockList.value || !stockList.value.length) {
            return;
        }
        const stockIdsArr = stockList.value.map((stock) => stock.stockId);
        const stockIds = stockIdsArr.join(',');
        await selfSelectedButtonRequest.post('add-wch', { stockIds });
        stockIdsArr.forEach((stockId) => {
            // 检查是否被添加过自选的
            const isSelected = selfSelectedMap[stockId];
            if (!isSelected) {
                set(selfSelectedMap, stockId, true);
                props.showAddWchCount && set(wchNumMap, stockId, (wchNumMap[stockId] || 0) + 1);
            }
        });
    };

    const initSelectStatus = () => {
        if (!stockList.value || !stockList.value.length) {
            return;
        }
        stockList.value.map(async (stock) => await getSelectStatus(stock));
    };

    return {
        selfSelectedMap,
        initSelectStatus,
        setSelectStatus,
        addAll
    };
};
